import React from "react";
import { Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

export default function ProtectedOtpRoute({ children }) {
  const otpAllowed = localStorage.getItem("otpAllowed");
  <ToastContainer  autoClose={3000} />

  if (otpAllowed !== "true") {
    return <Navigate to="/register" replace />;
  }

  return children;
}